// extracted by mini-css-extract-plugin
export default {"loaderwrapper":"style_loaderwrapper__31Kd4","spinner":"style_spinner__dPwlx","spin":"style_spin__m2mhy"};